import TableTemplate from "src/Tables/TableTemplate/tableTemplate";
import { CommonTableUI } from "src/Tables/TableTemplate/common";
import { getWorkerHostPermissionTable } from "src/Requests/workerHostPermission";
import {
  IWorkerHostPermissionReport,
  IWorkerHostPermissionSearchParam,
} from "src/Interfaces/workerHostPermission";

const WorkerHostPermission = () => {
  return (
    <div className="w-full h-screen px-3 pt-5">
      <TableTemplate<
        IWorkerHostPermissionSearchParam,
        IWorkerHostPermissionReport
      >
        getDataTable={getWorkerHostPermissionTable}
        TableUI={({ reports, onAction, setSortingType, sortingType }) => (
          <CommonTableUI
            reports={reports}
            onAction={onAction}
            setSortingType={setSortingType}
            sortingType={sortingType}
            tableBoxClassName="!mx-0 max-h-[calc(100vh-120px)] overflow-auto"
          />
        )}
        pagesize={200}
        refreshTableTime={10000}
        searchParameters={{}}
        withSort
      />
    </div>
  );
};

export default WorkerHostPermission;
